import { useLogout } from '@hooks/useLogout';
import { useEffect } from 'react';

export const LogoutPage = () => {
  const { logout } = useLogout();
  useEffect(() => {
    logout();
  }, [logout]);
  return null;
};
